{
  "en": {
    "tools": {
      "descriptions": {
        "verseGuide": "Comprehensive travel guide with detailed system maps, points of interest, and exploration routes across the Star Citizen universe",
        "starCitizenTools": "Community-driven wiki with extensive documentation on ships, weapons, locations, gameplay mechanics, and lore",
        "verseintel": "Star Citizen knowledge graph that links dev statements, patch notes, articles, Spectrum posts and videos into one searchable, cross-referenced archive",
        "starship42": "Interactive 3D ship viewer with detailed exterior and interior models, component placement, and size comparisons",
        "erkul": "Advanced DPS calculator and ship loadout optimizer with detailed weapon statistics and component comparisons",
        "starjump": "2D fleet visualization tool for creating beautiful ship layouts and fleet organization charts",
        "itemFinder": "Comprehensive item and equipment location database with real-time availability tracking across the verse",
        "starHangar": "Trusted marketplace for Star Citizen ship pledges and packages with secure trading and price tracking",
        "shinytracker": "Personal progress tracker for missions, reputation, achievements, and exploration goals with detailed statistics",
        "uexCorp": "Real-time commodity trading platform with price tracking, trade route optimization, and market analysis tools",
        "cargoGridViewer": "3D cargo grid viewer showing cargo hold dimensions and container fitting for all ships",
        "scmdb": "Browse missions, rewards, reputation paths, mining resources and more for Star Citizen",
        "regolith": "Star Citizen mining tool with rock scanning, refining calculations, and mining head comparisons",
        "spviewer": "Ship performance analysis tool with detailed flight characteristics, speed comparisons, and maneuverability data",
        "citizenId": "Star Citizen identity verification and OAuth authentication service for community tools",
        "hauler": "Cargo hauling route planner and profit calculator for Star Citizen traders"
      },
      "categories": {
        "trading": "Trading & Economy",
        "loadouts": "Ship Loadouts & Combat",
        "mining": "Mining",
        "missions": "Missions & Database",
        "fleet": "Fleet Management"
      },
      "discontinued": "This project has been discontinued.",
      "discontinuedHeading": "Discontinued Projects"
    }
  }
}
